/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetExtensionConfigRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/utility_messages.pb'
import {GetExtensionConfigResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/utility_messages.pb'


export const getExtensionConfig = (request: GetExtensionConfigRequest, options?: CashRequestOptions) => post<GetExtensionConfigRequest, GetExtensionConfigResponse>("/2.0/cash/get-extension-config", request, {...options, rejectOnError: true })